import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime.js';
import { forwardRef } from 'react';
import cn from 'classnames';
import styles from './Input.module.css.js';

var _excluded = ["className", "controlName", "disabled", "error", "id", "onChange", "placeholder", "type", "invalid", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    controlName = props.controlName,
    disabled = props.disabled,
    error = props.error,
    id = props.id,
    onChange = props.onChange,
    placeholder = props.placeholder,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    invalid = props.invalid,
    value = props.value,
    restProps = _objectWithoutProperties(props, _excluded);
  return jsxs(Fragment, {
    children: [jsx("input", _objectSpread({
      className: cn(styles.qdInput, className, _defineProperty({}, styles.invalid, invalid)),
      disabled: disabled,
      id: id,
      name: controlName,
      placeholder: placeholder,
      type: type || 'text',
      value: value,
      onChange: onChange,
      ref: ref
    }, restProps)), error !== undefined && jsx("div", {
      className: styles.error,
      children: error
    })]
  });
});

export { Input };
